import DWGuideBox from './guideBox'
export const components = {
  DWGuideBox
}

const plugins = {}

export default {
  install (Vue) {
    Object.keys(components).forEach((name) => {
      const comp = components[name]
      if (!comp.name) {
        throw new Error('component name required: ', comp)
      }
      Vue.component(comp.name, comp)
    })
  },
  ...components
}
